export const statusOptions = [
  { value: "", label: "All" },
  { value: "0", label: "Active" },
  { value: "1", label: "Deactive" },
];

export const actionLogs = [
  { value: "", label: "All" },
  { value: "Add", label: "Add" },
  { value: "Edit", label: "Edit" },
  { value: "Deactive", label: "Deactive" },
];

export const categoryLog = [
  { value: "", label: "All" },
  { value: "Group", label: "Group" },
  { value: "User Registration", label: "User Registration" },
  { value: "Channel", label: "Channel" },
];
